export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
  count: number;
}

export const categories: Category[] = [
  {
    slug: 'yingshiju',
    name: '影视剧',
    description: '最新热门国产电视剧、网络剧、电影大全',
    icon: 'ri-movie-2-line',
    count: 1280,
  },
  {
    slug: 'zongyi',
    name: '综艺',
    description: '热门综艺节目、真人秀、脱口秀全集',
    icon: 'ri-tv-2-line',
    count: 856,
  },
  {
    slug: 'jilupian',
    name: '纪录片',
    description: '高质量国产纪录片、人文纪实、自然探索',
    icon: 'ri-camera-lens-line',
    count: 432,
  },
  {
    slug: 'duanshipin',
    name: '短视频',
    description: '创意短视频、搞笑段子、生活记录、才艺展示',
    icon: 'ri-vidicon-line',
    count: 3560,
  },
  {
    slug: 'dongman',
    name: '动漫',
    description: '国产动漫、动画电影、番剧精选',
    icon: 'ri-emotion-line',
    count: 678,
  },
  {
    slug: 'jiaoyu',
    name: '教育',
    description: '在线课程、知识科普、技能学习视频',
    icon: 'ri-book-open-line',
    count: 945,
  },
  {
    slug: 'yinyue',
    name: '音乐',
    description: 'MV、演唱会、音乐现场、原创音乐视频',
    icon: 'ri-music-2-line',
    count: 1120,
  },
  {
    slug: 'tiyu',
    name: '体育',
    description: '体育赛事、精彩集锦、运动教学视频',
    icon: 'ri-basketball-line',
    count: 534,
  },
];